import dayjs from 'dayjs';
import 'dayjs/locale/ja';
import { WMSelectOption } from '@walkme/wm-ui';
import { setMonth as setDateMonth, startOfMonth, startOfYear, setYear } from 'date-fns';
import i18n from '../../../../../../infrastructure/I18n/i18n';
import { enUS, ja } from 'date-fns/locale';
import { LanguageCode } from '@communication-center/data-objects';

export const DEFAULT_FORMAT = 'YYYY-MM-DD hh:mm A';

export const stringifyDateTime = (date: Date, format: string) => {
    const locale = i18n.language;
    return dayjs(date).locale(locale).format(format);
};

export const getMonths = () => {
    const months: Date[] = [];

    for (let month = 0; month <= 11; month++) {
        const anyDate = new Date();
        months.push(setDateMonth(startOfMonth(anyDate), month));
    }

    return months;
};

export const getYears = (from: Date, to: Date) => {
    const years = [];

    for (let year = from.getFullYear(); year <= to.getFullYear(); year += 1) {
        const anyDate = new Date();
        years.push(setYear(startOfYear(anyDate), year));
    }

    return years;
};

export const parseDateToWMSelectOption = (date: string): WMSelectOption => ({
    value: date,
    label: date
});

export const parseSelectionToDate = (year: string, month: string, months: string[]): Date => new Date(parseInt(year), months.indexOf(month));

export const getFnsLocale = (languageCode: LanguageCode) => {
    const localeMap = {
        [LanguageCode.EN]: enUS,
        [LanguageCode.JA]: ja
    };
    return localeMap[languageCode] ?? localeMap[LanguageCode.EN];
};
